import { SECTION } from 'src/app/@core/conf/acl';
import { Navigation } from 'src/app/@theme/types/navigation';
import { environment } from 'src/environments/environment';

export const _menus: Navigation[] = [
	{
		id: 'navigation',
		title: 'Navigation',
		type: 'group',
		icon: 'icon-navigation',
		children: [
			{
				id: 'dashboard',
				title: 'dashboard',
				type: 'item',
				classes: 'nav-item',
				url: '/dashboard',
				icon: '#custom-status-up',
				section: SECTION.DASHBOARD
			},
			{
				id: 'catalogue',
				title: 'catalogue',
				type: 'collapse',
				icon: '#custom-box-1',
				section: SECTION.CATALOG,
				children: [
					{
						id: 'product',
						title: 'products',
						type: 'item',
						classes: 'nav-item',
						url: '/product',
						section: SECTION.PRODUCTS
					},
					{
						id: 'attribute',
						title: 'attributes',
						type: 'item',
						classes: 'nav-item',
						url: '/attribute',
						section: SECTION.ATTRIBUTES
					},
					{
						id: 'attributeset',
						title: 'attributeset',
						type: 'item',
						classes: 'nav-item',
						url: '/attributeset',
						section: SECTION.ATTRIBUTE_SET
					},
					{
						id: 'attributesprops',
						title: 'attributes-props',
						type: 'item',
						url: '/attributesprops',
						classes: 'nav-item',
						section: SECTION.ATTRIBUTE_PROPS
					},
					{
						id: 'taxonomy',
						title: 'taxonomies',
						type: 'item',
						classes: 'nav-item',
						url: '/taxonomy',
						section: SECTION.TAXONOMIES
					}
				]
			},
			{
				id: 'slider',
				title: 'slider',
				type: 'item',
				classes: 'nav-item',
				url: '/slider',
				icontype: 'fa',
				icon: 'fas fa-images',
				section: SECTION.SLIDER
			},
			{
				id: 'popup',
				title: 'popup',
				type: 'item',
				classes: 'nav-item',
				url: '/popup',
				icontype: 'fa',
				icon: 'fas fa-images',
				section: SECTION.SLIDER
			}
		]
	},
	{
		id: 'shopping',
		title: 'shopping',
		type: 'group',
		icon: 'icon-navigation',
		section: SECTION.SHOPPING,
		children: [
			{
				id: 'cart',
				title: 'orders',
				type: 'item',
				classes: 'nav-item',
				url: '/orders',
				icontype: 'fa',
				icon: 'fas fa-file-alt',
				section: SECTION.ORDERS,
			},
			{
				id: 'invoice',
				title: 'invoices',
				type: 'item',
				classes: 'nav-item',
				url: '/invoice',
				icontype: 'fa',
				icon: 'fas fa-file-contract',
				section: SECTION.INVOICES
			},
			{
				id: 'cartcart',
				title: 'cartcarts',
				type: 'item',
				classes: 'nav-item',
				url: '/carts',
				icontype: 'fa',
				icon: 'fas fa-shopping-cart',
				section: SECTION.CARTS
			},
			{
				id: 'orderreturn',
				title: 'orderreturns',
				type: 'item',
				classes: 'nav-item',
				url: '/orderreturn',
				icontype: 'fa',
				icon: 'fas fa-undo-alt',
				section: SECTION.ORDER_RETURNS
			},
			{
				id: 'coupon',
				title: 'coupon',
				type: 'item',
				classes: 'nav-item',
				url: '/coupon',
				icontype: 'fa',
				icon: 'fas fa-ticket-alt',
				section: SECTION.COUPONS
			},
			{
				id: 'promorule',
				title: 'promo-rules',
				type: 'item',
				classes: 'nav-item',
				url: '/promorule',
				icontype: 'fa',
				icon: 'fa fa-gavel',
				section: SECTION.PROMO_RULES
			}
		]
	},
	{
		id: 'customer',
		title: 'customer',
		type: 'group',
		icon: 'icon-navigation',
		section: SECTION.CUSTOMER,
		children: [
			{
				id: 'customer',
				title: 'customers',
				type: 'item',
				classes: 'nav-item',
				url: '/customer',
				icon: '#custom-user',
				section: SECTION.CUSTOMER,
			},
			{
				id: 'customergroup',
				title: 'customergroup',
				type: 'item',
				classes: 'nav-item',
				icon: '#custom-profile-2user-outline',
				url: '/customergroups',
				section: SECTION.CUSTOMER_GROUPS
			},
			{
				id: 'newsletter',
				title: 'newsletter',
				type: 'item',
				classes: 'nav-item',
				icontype: 'fa',
				icon: 'fa fa-envelope',
				url: '/newsletter',
				section: SECTION.NEWSLETTER
			},
			{
				id: 'request',
				title: 'requests',
				type: 'item',
				classes: 'nav-item',
				icontype: 'fa',
				icon: 'fa fa-question-circle',
				url: '/request',
				section: SECTION.REQUESTS
			},
			{
				id: 'influencer',
				title: 'influencer',
				type: 'item',
				classes: 'nav-item',
				icontype: 'fa',
				icon: 'far fa-thumbs-up',
				url: '/influencer',
				section: SECTION.INFLUENCERS
			}
		]
	},
	{
		id: 'purchasing',
		title: 'purchasing',
		type: 'group',
		icon: 'icon-navigation',
		section: SECTION.PURCHASING,
		children: [
			{
				id: 'vendors',
				title: 'vendors',
				type: 'item',
				classes: 'nav-item',
				icontype: 'fa',
				icon: 'fa fa-industry',
				url: '/vendor',
				section: SECTION.VENDORS
			},
			{
				id: 'lowstock',
				title: 'lowstock',
				type: 'item',
				classes: 'nav-item',
				icontype: 'fa',
				icon: 'fa fa-cubes',
				url: '/lowstock',
				section: SECTION.LOWSTOCK
			},
			{
				id: 'purchaseorder',
				title: 'purchase-order',
				type: 'item',
				classes: 'nav-item',
				icontype: 'fa',
				icon: 'fas fa-file-contract',
				url: '/purchaseorder',
				section: SECTION.PURCHASE_ORDERS
			}
		]
	},
	{
		id: 'admin',
		title: 'admin',
		type: 'group',
		icon: 'icon-navigation',
		section: SECTION.ADMIN,
		children: [
			{
				id: 'bousers',
				title: 'bousers',
				type: 'collapse',
				icon: '#custom-user',
				section: SECTION.USERS,
				children: [
					{
						id: 'users',
						title: 'users',
						type: 'item',
						classes: 'nav-item',
						url: '/users',
						section: SECTION.ADMIN,
					},
					{
						id: 'roles',
						title: 'roles',
						type: 'item',
						classes: 'nav-item',
						url: '/roles',
						section: SECTION.ADMIN_ADVANCED,
					}

				]
			},
			{
				id: 'storefronts',
				title: 'storefronts',
				type: 'item',
				classes: 'nav-item',
				icon: 'fas fa-store',
				icontype: 'fa',
				url: '/storefronts',
				section: SECTION.ADMIN_ADVANCED,
			},
			{
				id: 'lists',
				title: 'lists',
				type: 'item',
				classes: 'nav-item',
				icon: 'fas fa-list',
				icontype: 'fa',
				url: '/lists',
				section: SECTION.ADMIN_ADVANCED,
			},
			{
				id: 'seo',
				title: 'seo',
				type: 'item',
				classes: 'nav-item',
				icon: 'fa fa-search',
				icontype: 'fa',
				url: '/seo',
				section: SECTION.SEO
			},
			{
				id: 'cms',
				title: 'cms',
				type: 'item',
				classes: 'nav-item',
				icon: 'fa fa-laptop-code',
				icontype: 'fa',
				url: '/cms',
				section: SECTION.CMS
			},

			{
				id: 'webarticles',
				title: 'webarticle',
				type: 'item',
				classes: 'nav-item',
				icontype: 'fa',
				icon: 'fa fa-newspaper',
				url: '/webarticle',
				section: SECTION.WEB_ARTICLES
			},
			{
				id: 'i18n',
				title: 'localization',
				type: 'collapse',
				icon: '#custom-global',
				section: SECTION.I18N,
				children: [{
					id: 'language',
					title: 'langs',
					type: 'item',
					url: '/language',
					classes: 'nav-item',
				},
				{
					id: 'labels',
					title: 'i18n',
					type: 'item',
					url: '/i18n',
					classes: 'nav-item',
					section: 'section.i18n'
				},


				]
			},
			{
				id: 'zone',
				title: 'areas',
				type: 'collapse',
				icon: '#custom-layer',
				section: SECTION.ZONES,
				children: [
					{
						id: 'shipmentexception',
						title: 'shipmentexceptions',
						type: 'item',
						url: '/shipmentexception',
					},
					{
						id: 'shipmentclass',
						title: 'shipmentclass',
						type: 'item',
						url: '/shipmentclass',
					},
					{
						id: 'shipmentthreshold',
						title: 'shipmentthreshold',
						type: 'item',
						url: '/shipmentthreshold',
					},
					{
						id: 'country',
						title: 'countries',
						type: 'item',
						url: '/country'
					},
					{
						id: 'province',
						title: 'provinces',
						type: 'item',
						url: '/province'
					},
					{
						id: 'city',
						title: 'cities',
						type: 'item',
						url: '/city'
					}
				]
			},
			{
				id: 'conf',
				title: 'configuration',
				type: 'collapse',
				icon: '#custom-setting-outline',
				section: SECTION.ADMIN,
				children: [
					{
						id: 'lists',
						title: 'lists',
						type: 'item',
						classes: 'nav-item',
						url: '/lists',

					},
					{
						id: 'i18n',
						title: 'localizations',
						type: 'item',
						classes: 'nav-item',
						url: '/i18n',
					},
					{
						id: 'vat',
						title: 'vat',
						type: 'item',
						classes: 'nav-item',
						url: '/vat'
					},
					{
						id: 'vatregion',
						title: 'vatregion',
						type: 'item',
						classes: 'nav-item',
						url: '/vatregion'
					},
					{
						id: 'cache',
						title: 'cache',
						type: 'item',
						classes: 'nav-item',
						url: '/cache',
					},

				]
			},
			{
				id: 'advanced',
				title: 'advanced',
				type: 'collapse',
				icon: '#custom-setting-outline',
				section: SECTION.ADMIN_ADVANCED,
				children: [
					{
						id: 'conf',
						title: 'system',
						type: 'item',
						classes: 'nav-item',
						url: '/conf',

					},

					{
						id: 'extbackgroundtask',
						title: 'extbackgroundtask',
						type: 'item',
						classes: 'nav-item',
						url: '/extbackgroundtask'
					}

				]
			}
		]
	},

];


export function getMenu(): Navigation[] {

	if (!environment.hide || !environment.hide.length) {
		return _menus;
	}

	const hide = environment.hide as string[];



	return _menus.reduce((menu: Navigation[], n: Navigation) => {
		if (!hide.includes(n.id)) {
			if (n.children) {
				n.children = n.children.reduce((menu2: Navigation[], n2: Navigation) => {
					if (!hide.includes(n2.id)) {
						if (!hide.includes(n2.id)) {
							if (n2.children) {
								n2.children = n2.children.filter((n3: Navigation) => !hide.includes(n3.id));
							}
						}
						menu2.push(n2);
					}
					return menu2;
				}, [])
			}
			menu.push(n);
		}
		return menu;
	}, [])
}
